import React, { ReactNode } from 'react'
import { AttackStatus } from '../../attack-status'
import {
  MetadataList,
  metadataListItemCss,
  MetadataListItem
} from '../../../legacy-design-system/metadata'
import { css, cx } from '@emotion/css'
import { AttackStatusBadge } from '../../badge'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { MetadataItemWithOverflow } from '../../../legacy-design-system/metadata/metadata-item-with-overflow'

function AttackEventMetadatalistItem({
  label,
  value
}: {
  readonly label: any
  readonly value: ReactNode
}) {
  return (
    <MetadataListItem
      className={css`
        margin-bottom: 10px;
      `}
      label={label}
      value={value}
    />
  )
}

export interface Props {
  readonly result: AttackStatus
  readonly received: string
  readonly application: {
    readonly name: string
  }
  readonly url?: string
  readonly server: {
    readonly name: string
    readonly environment: string
  }
  readonly httpRequest: unknown
  readonly attackers: string[]
}

export function EventMetadata({
  result,
  received,
  application,
  httpRequest,
  server,
  url,
  attackers
}: Props) {
  return (
    <MetadataList>
      <li
        className={cx(
          metadataListItemCss,
          css`
            &:not(:last-child)::after {
              margin-left: 0;
              content: '';
            }

            margin-bottom: 10px;
          `
        )}
      >
        <AttackStatusBadge status={result} />
      </li>
      <AttackEventMetadatalistItem
        label={<FormattedMessage id="title_date" />}
        value={<FormattedDate value={received} />}
      />
      <AttackEventMetadatalistItem
        label={<FormattedMessage id="title_application" />}
        value={application.name}
      />
      {!!httpRequest && typeof url !== 'undefined' && (
        <AttackEventMetadatalistItem
          label={<FormattedMessage id="title_url" />}
          value={url}
        />
      )}
      <AttackEventMetadatalistItem
        label={<FormattedMessage id="title_environment_server" />}
        value={server.environment}
      />
      <AttackEventMetadatalistItem
        label={<FormattedMessage id="title_server" />}
        value={server.name}
      />
      {attackers.length > 0 && (
        <MetadataItemWithOverflow items={attackers} labelId="title_username" />
      )}
    </MetadataList>
  )
}
